import { IContextualMenuItem, ContextualMenu } from '@fluentui/react/lib/ContextualMenu';
import { ContextMenu as RoosterJsContextMenu } from 'roosterjs-editor-plugins/lib/ContextMenu';
import * as ReactDOM from 'react-dom';
import * as React from 'react';

export default class OwaContextMenu extends RoosterJsContextMenu<IContextualMenuItem> {
    constructor() {
        super({
            render,
            dismiss,
        });
    }
}

function render(
    container: HTMLElement,
    items: (IContextualMenuItem | null)[],
    onDismiss: () => void
) {
    let dividerKey = 0;
    const allItems: IContextualMenuItem[] = items.map(
        item =>
            item || {
                name: '-',
                key: 'divider_' + (dividerKey++).toString(),
            }
    );

    if (allItems.length > 0) {
        ReactDOM.render(
            <ContextualMenu
                shouldFocusOnMount={true}
                target={container}
                onDismiss={onDismiss}
                items={allItems}
            />,
            container
        );
    }
}

function dismiss(container: HTMLElement) {
    ReactDOM.unmountComponentAtNode(container);
}
